import React,{useState} from 'react'
import StudentAvatar from '../../assets/images/student-avatar.png';
import CameraIcon from '../../assets/images/camera.png';
import { StateUseContext } from '../../context/UserDetailContext';
import swal from 'sweetalert';
import { uploadProfile } from '../../actions/StudentAction';

const ProfileInfo = () => {
    const {userDetail,setUserDetail} = StateUseContext();
    const {id,name,form_num,course_name,coupon_code,used_coupon,profile_percentage,profile_picture} = userDetail !==undefined && userDetail

    const [profilePic, setProfilePic] = useState({name : 'profilePic', value : ''});
    const [profileImg,setProfileImg] = useState();
    const [loadingImg,setLoadingImg] = useState(false)

    const [couponCode] = useState(coupon_code);
    const [copied, setCopied] = useState(false);

    const profileHandleChange = async(e) => {
        setLoadingImg(true)
        const filesValue = e.target.files;
        const formData = new FormData();
        formData.append('myImage',filesValue[0])
        formData.append('id',id)
        
        await uploadProfile(formData).then(res => {
         
            if (res.status) {
                setLoadingImg(false)
                setUserDetail({...userDetail,...res?.data})
                setProfileImg(res.profile_picture)
                swal('Profile picture uploaded successfully','','success')
            }
            else{
                setLoadingImg(false)
                swal('Something went wrong','','error')
            }
        
        })
        .catch(err => {
            console.log(err);
        })
    }

    const handleImgError = e => {
        e.target.src = StudentAvatar;
        // e.target.className = 'card-img-top logoImg_error'
      }

      const copyToClipboard = () => {
        navigator.clipboard.writeText(couponCode).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Reset copied status after 2 seconds
        });
      };

  return (
    <section className="about_user_profileWrap">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-md-7">
                    <div className="profile_pic_about_user">
                        <div className="profile_pic">
                            <input type="file" value={profilePic.value} accept="image/png, image/gif, image/jpeg" id="profileImg"
                                     onChange={e => profileHandleChange(e)}  className="d-none"/>
                            <label htmlFor="profileImg" className={loadingImg?'loading_profileImg':''}>
                                {loadingImg ? 'Uploading...' :
                                (profile_picture || profileImg) ? 
                                <img src={`${profileImg?profileImg:profile_picture}`} 
                                 onError={handleImgError}
                                alt="Student avatar" title='Change Picture'/>
                                :<img src={StudentAvatar}  alt="Profile avatar" title='Change Picture'/>
                                }
                            </label>
                            <img src={CameraIcon} htmlFor="profile_pic" alt="Camera icon" title='Change Picture'/>
                        </div>
                        <div className="about_userProfile">
                            <h5>{name}</h5>
                            <p>ALLEN Form NO. : {form_num}</p>
                            <p className="badge-custom-course bg-info">Course : {course_name}</p>

                            <div className="widget-content-outer w-100">
                            <div className="widget-content-wrapper">
                                <div className="widget-content-left pr-2 fsize-1">
                                    <span className="widget-numbers fw-bold mt-0 fsize-3 text-primary">
                                        Profile Completion : {profile_percentage}%</span>
                                </div>
                                <div className="widget-content-right w-100 mt-2">
                                    <div className="progress-bar-xs progress">
                                        <div className="progress-bar bg-secondary" role="progressbar"
                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"
                                            style={{width : profile_percentage+ '%'}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        
                        </div>

                        
                        
                    </div>
                </div>
                <div className="col-md-5 align-self-end">
                    {coupon_code && (
                            <div className="d-flex flex-wrap justify-content-end align-items-end w-100 text-end">
                            
                            {used_coupon === 0 && (
                                <div className="couponCode_contain me-2">
                                    <div
                                        className='contain_coupon_code my-2 my-lg-0'
                                        onClick={copyToClipboard}
                                        title="Click to copy"
                                    > 
                                    <span className='text-muted'>Coupon Code:</span> &nbsp; <span className='text-secondary'><b>{couponCode}</b> </span>
                                        <span className="clipboard_icon ms-auto ms-md-2">
                                            <svg width="16" height="16" fill="currentColor" className="bi bi-clipboard" viewBox="0 0 16 16">
                                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
                                            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
                                            </svg>
                                        {copied ? 'Copied!':'Copy'} 
                                        </span>
                                    </div>
                            </div>
                            )}
                            
                            <a href={`${process.env.REACT_APP_PUBLIC_URL}/psychometric-test`} className="btn btn-sm btn-default psycho_link">
                            <svg  width="16" height="16" fill="currentColor" className="bi bi-link-45deg me-1" viewBox="0 0 16 16">
                            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                            </svg>
                            Psychometric Test</a>
                        </div>
                    )}
                        
                </div>

                <div className="w-100"></div>
                <div className="col-md-7">
                    <div className="profile_right_col d-flex flex-wrap align-items-center justify-content-evenly">
                        {/* <div className="inner_item text-center">
                            <h3 className="fw-bold">04</h3>
                            <p>Exam</p>
                        </div>
                        <div className="inner_item text-center">
                            <h3 className="fw-bold">12</h3>
                            <p>Transaction</p>
                        </div>
                        <div className="inner_item text-center">
                            <h3 className="fw-bold">0</h3>
                            <p className="mb-0">Add Siblings</p>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
     </section>
  )
}

export default ProfileInfo